import React, { forwardRef } from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import InputGroup from 'react-bootstrap/InputGroup';
import './Textbox.scss';

const Textbox = forwardRef(function Textbox(props, ref) {
    const {
        isSearch, value, field, disabled = false,
        allowFloat = true, allowNegative = true, className, onChange, ...otherProps
    } = props;

    // Expect state to be controlled when onChange event defined.
    // Otherwise "local" available when uncontrolled.
    const isControlled = (typeof onChange === 'function');
    const [localValue, setLocalValue] = React.useState(value);

    const [showClear, setShowClear] = React.useState(false);

    const handleChange = (e) => {
        let newValue = e.target.value;
        if (newValue && !allowNegative && parseInt(newValue) < 0) {
            newValue = '0';
        }
        if (newValue && !allowFloat) {
            newValue = `${parseInt(newValue)}`;    // chop the float value
        }

        if (isControlled) {
            onChange(e, field, newValue);
        } else {
            setLocalValue(newValue);
        }

        if (isSearch) {
            if (e.target.value.length > 0)
                setShowClear(true)
            else
                setShowClear(false)
        }
    }

    const handleClear = (e) => {

        if (isControlled) {
            onChange(e, field, '');
        } else {
            setLocalValue('');
        }

        setShowClear(false);
    }

    let renderValue = (isControlled) ? value : localValue;

    if (isSearch) {
        return (
            <InputGroup>
                <InputGroup.Text><i className="fas fa-search"></i></InputGroup.Text>
                <Control
                    ref={ref}
                    value={renderValue}
                    onChange={handleChange}
                    onKeyDown={(e) => { if (e.key === 'Escape') handleClear(e) }}
                    className={`${className} text-input-search`}
                    disabled={disabled}
                    {...otherProps}
                />
                <InputGroup.Text className={showClear ? '' : 'd-none'} data-testid="text-clear-wrapper">
                    <Button onClick={handleClear} variant="link" disabled={disabled}>
                        <i className="fas fa-times"></i>
                    </Button>
                </InputGroup.Text>
            </InputGroup>
        );
    }
    else {
        return (
            <Control
                ref={ref}
                value={renderValue}
                onChange={handleChange}
                disabled={disabled}
                {...otherProps}
            />
        );
    }
});
export default Textbox;

const Control = forwardRef(function Control(props, ref) {

    const {
        value, placeholder, type = "text",
        onChange, onKeyDown, className, disabled, ...otherProps
    } = props;

    return (
        <Form.Control
            ref={ref}
            value={value}
            type={type}
            placeholder={placeholder}
            onChange={onChange}
            onKeyDown={onKeyDown}
            className={`textbox ${className ?? ''} ${type === 'number' ? 'text-input-small' : ''}`}
            disabled={disabled}
            {...otherProps}
        />   
    );
})